import { useQuery } from "@tanstack/react-query";

import apiDal from "../config/apiDal";
import { Place } from "../types";

type GetPlacesParams = {
	locale?: string;
	portalUid: string;
};

const fetchPlaces = async (locale: string = "en-us", portalUid: string): Promise<Place[]> => {
	const response = await apiDal.post("/queries/public/fetch", {
		query: "getLossPlace",
		bind: {
			locale: locale.toLowerCase(),
			enterpriseUid: portalUid,
		},
	});

	return response.data.result;
};

export const useGetPlacesByEnterpriseUid = ({ locale, portalUid }: GetPlacesParams) => {
	return useQuery<Place[]>({
		queryKey: ["getLossPlace", locale, portalUid],
		queryFn: () => fetchPlaces(locale, portalUid),
		enabled: !!portalUid,
		initialData: []
	});
};
